import BenefitItem from './BenefitItem';
import { listClassName, summaryBodyClassName } from './styles';

const SummaryBody = () => {
  return (
    <div className={summaryBodyClassName}>
      <ul className={listClassName}>
        <li>
          <BenefitItem label="Up to 100 card posts" />
        </li>
        <li>
          <BenefitItem label="Upload/add photo posts" />
        </li>
        <li>
          <BenefitItem label="Directly send card via e-mail" />
        </li>
      </ul>
    </div>
  );
};

SummaryBody.displayName = 'SummaryBody';

export default SummaryBody;
